import { useTranslation } from "react-i18next";
import SessionModel from "../../../api/models/SessionModel";
import StartableRoomCard from "./StartableRoomCard";
import AbsenceRoomCard from "./AbsenceRoomCard";

type ActiveRoomCardProps = {
  session: SessionModel;
  onEnter: (session: SessionModel) => void;
};

export default function ActiveRoomCard(props: ActiveRoomCardProps) {
  const { t } = useTranslation("", {
    keyPrefix: "page.tutor.dashboard.room",
  });
  const { session, onEnter } = props;

  if (session.isAbsenceBySystem) {
    return (
      <AbsenceRoomCard
        participantName={session.student!.name}
        sessionNumber={session.sessionNumber || 0}
        telawahName={session.sessionTelawahName!}
        profilePictureUrl={session.student!.profile_picture_url}
        sessionStatusText={t(session.statusReported)}
        sessionStartTime={session.start_time!}
      />
    );
  }

  return (
    <StartableRoomCard
      actionButtonText={t("enterSession")}
      isEvaluationSession={!!session.student?.isLearner}
      onEnter={() => onEnter(session)}
      participantName={session.student!.name}
      readingProgress={session.student!.lastQuranPageReached}
      sessionNumber={session.sessionNumber || 0}
      telawahName={session.sessionTelawahName!}
      profilePictureUrl={session.student!.profile_picture_url}
      sessionStatusText={t(session.statusReported)}
    />
  );
}
